export const validation = {
  headingMaxChar: 24,
  paragraphMaxChar: 120,
  scrollMaxChar: 30,
  title: { required: true },
  buttons: {
    min: 0,
    max: 2
  }
}